import React, { Component,
} from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import {
  Modal,
  Button,
  message,
} from "antd";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import fetchHandler from "@/fetch/fetchHandler";
import { getEquipmentList, getCityList } from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";
@CityDataFilterHoc
// eslint-disable-next-line arrow-parens
@connect(state => state)
class EquipmentListModal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.equipmentListModal;
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      dataSource: [],
    };
  }

  componentWillMount() {
    this.init();
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    };

    generateTableButtons() {
      return (
        <div className="table-btn-group">
          <Button type="primary" style={{ marginRight: "5px" }} onClick={() => this.selectCurrent()}>{this.internationalization.btn6}</Button>
          <Button type="primary" onClick={() => this.batchAdd()}>{this.internationalization.btn2}</Button>
        </div>);
    }

    fetchStationList = (params) => {
      fetchHandler(getEquipmentList, {
        ...params,
      }).then((res) => {
        if (res && res.code === "success") {
          const dataSource = res.data;
          this.setState({
            dataSource,
            selectedRows: this.props.selectedStations,
            selectedRowKeys: this.props.selectedStations
              ? this.props.selectedStations.map((item) => item.key) : [],
          }, () => {
            this.setState({
              ...this.init(),
            });
          });
        }
      });
    }

    init() {
      this.formConfig = {
        childItems: [
          {
            type: "areaPicker",
            isPickArea: !0,
            placeholder: this.internationalization.placeholder1, // '请选择地区',
            pickOnSelect: true,
            param: {
              name: "cityId", // 与form表单绑定的参数名
              type: "array",
            },
            // defaultValue: ['34'], //默认值
            required: !1,
            labelName: this.internationalization.title1, // '地区',
            className: "allshow",
            sourceApi: getCityList,
            mapKey: {
              label: "label",
              value: "value",
              children: "children",
            },
          }, {
            type: "input",
            inputType: "text",
            placeholder: this.internationalization.title2, // '电站名称',
            param: {
              name: "stubGroupName",
              type: "string",
            },
            labelName: this.internationalization.title2, // '电站名称'
          }, {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                text: this.internationalization.btn1, // '查询',
                // icon: 'search',
                type: "primary",
                // handler: (e, param) => {
                //     this.fetchStationList(param);
                // }
              },
            ],
          },
        ],
        layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
        formTarget: "submit", // 表单提交类型，设置grid则为更新grid
        autoLoadGrid: !1, // 设置为false不触发加载grid
        context: this,
        defaultParams: {},
        tableKey: "ac_stationList",
      };
      this.setState({
        tableConfig: {
          tableKey: "ac_stationList",
          tableColumns: [{
            name: this.internationalization.title3, // '枪编号',
            key: "key",
            colType: "textCol",
            align: "center",
          }, {
            name: this.internationalization.title1, // '地区',
            key: "cityName",
            colType: "textCol",
            align: "center",
          }, {
            name: this.internationalization.title2, // '电站名称',
            key: "stubGroupName",
            colType: "textCol",
            align: "center",
          }, {
            name: this.internationalization.btn5, // '操作',
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [{
              type: "href",
              actionName: this.internationalization.btn4, // '添加',
              handler: (record) => {
                this.props.add([record]);
              },
            },
              // ,{
              //     type: 'confirm',
              //     actionName: '删除',
              //     handler: (record) => {
              //         this.props.delete([record]);
              //     }
              // }
            ],
          }],
          tableParam: {
            pagecount: 10,
          },
          tableChange: () => {

          },
          tableInfo: {
            hasRow: !0, // 是否显示checkbox
            footer: this.generateTableButtons(),
            rowSelection: {
              selectedRowKeys: this.state ? this.state.selectedRowKeys : [],
              onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                  selectedRowKeys,
                  selectedRows,
                }, () => {
                  this.setState({
                    ...this.init(),
                  });
                });
              },
            },
          },
          dataApi: getEquipmentList,
          autoRefresh: !1, // 设置为true 直接加载grid数据
        },
      });
    }

    fetchApi = (param) => {
      const newParam = param;
      const selectCity = (param.cityId && param.cityId.split(",")) || [];
      switch (selectCity.length) {
        case 1:
          message.error(this.internationalization.msg1);
          newParam.cityId = "error!";
          break;
        case 2:
          newParam.cityId = selectCity[1];
          break;
        case 3:
          newParam.cityId = selectCity[2];
          break;
        default:
          newParam.cityId = "";
          break;
      }

      // 当设置formTarget为grid时，执行自定义提交事件。
      if (this.formConfig.formTarget === "grid") {
        return;
      }
      // 请求fetch 对象，带入生成参数
      // 如果在modal中的表单提交，请执行这里
      if (this.props.modalSubmit) {
        return this.props.modalSubmit(param);
      } else {
        // 如果正常页面中的表单提交，请执行下面
        return RefreshGrid(this.context.store, "ac_stationList", newParam);
      }
    }

    selectAll = () => {
      const dataSource = [...this.state.dataSource];
      const selectedRows = [...this.state.selectedRows];
      // const selectedRowKeys = [...this.state.selectedRowKeys];
      let selected = true;
      if (selectedRows.length === dataSource.length) {
        selected = false;
      }
      this.setState({
        selectedRows: selected ? dataSource : [],
        selectedRowKeys: selected ? dataSource.map((item) => item.key) : [],
      }, () => {
        console.log(this.state.selectedRows);
        console.log(this.state.selectedRowKeys);
        this.setState({
          ...this.init(),
        });
      });
    }

    selectCurrent = () => {
      this.props.addCurrent(this.state.selectedRows);
    }

    batchAdd = () => {
      console.log(this.state.selectedRows);
      this.props.add(this.state.selectedRows);
    }

    render() {
      return (
        <Modal
          title={this.internationalization.title6}
          footer={null}
          visible={this.props.visible}
          destroyOnClose
          onCancel={this.props.cancel}
          width="1000px"
            >
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
          <GridTable config={this.state.tableConfig} />
        </Modal>
      );
    }
}

export default injectIntl(EquipmentListModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/taskManagement/equipmentListModal.js